import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { useFullscreen } from 'features/fullscreen';
import { SlidoChat, YoutubeChat } from './components';
import { VideoChatProps } from './types';

const ChatWrapper = styled('div')`
  ${(props: any) => {
    return `
      width: 100vw;
      height: 400px;

      ${props.theme.mediaQueries.desktop} {
        width: 425px;
        height: ${
          props['data-hastabs']
            ? props['data-fullscreen']
              ? 'calc(100vh - 141px)'
              : '645px'
            : props['data-fullscreen']
            ? 'calc(100vh - 81px)'
            : '705px'
        };
      }
    `;
  }}
`;

const Chat = ({ videoChatProvider, hasTabs, ...props }: VideoChatProps): ReactElement => {
  const [isFullscreen] = useFullscreen();

  return (
    <ChatWrapper data-fullscreen={isFullscreen} data-hastabs={hasTabs}>
      {videoChatProvider === 1 && <SlidoChat {...props} />}
      {videoChatProvider === 2 && <YoutubeChat {...props} />}
    </ChatWrapper>
  );
};
export default Chat;
